<template>
  <span :style="{ width: width }">
    <div v-if="service.params && service.params.length">
      定值参数：
      <br />
      <div
        v-for="(ff, index) in service.params"
        :key="'n' + index"
        class="sw-custom-field"
      >
        <span>{{ ff.name }}：{{ ff.value }}</span>
      </div>
    </div>

    <div v-if="service.variables && service.variables.length">
      <br />
      不定值参数：
      <br />
      <div
        v-for="(ff, index) in service.variables"
        :key="'v' + index"
        class="sw-custom-field"
      >
        <span>{{ ff.name }}</span>
      </div>
    </div>
    <el-select
      v-model="value"
      @change="selService"
      clearable
      filterable
      style="margin-top: 10px"
      placeholder="请选择接口"
    >
      <el-option
        v-for="item in options"
        :key="item.id"
        :label="item.interfacename"
        :value="item.id"
      ></el-option>
    </el-select>
    <el-button
      v-if="!showDetail"
      @click="openOrClose"
      type="text"
      class="sw-custom-btn"
    >
      详情
      <i class="el-icon-caret-bottom"></i>
    </el-button>
    <el-button
      v-if="showDetail"
      @click="openOrClose"
      type="text"
      class="sw-custom-btn"
    >
      收起
      <i class="el-icon-caret-top"></i>
    </el-button>
    <div v-if="showDetail">
      <el-row>
        <el-col>
          <span style="font-weight: bold">返回字段：</span>
        </el-col>
      </el-row>
      <div style="width: 100%">
        <div v-for="ff in service.fields" :key="ff" class="sw-custom-field">
          <span>{{ ff }}</span>
        </div>
      </div>
      <el-row>
        <el-col>
          <span style="font-weight: bold">接口查询结果：</span>
        </el-col>
      </el-row>
      <div id="testResult" style="height: 200px; width: 100%">
        {{ service.testResult }}
      </div>
    </div>
  </span>
</template>

<script>
import customUtil from '../../../util/customUtil'
import alertUtils from '../../../util/alertUtils'
export default {
  name: 'api-input',
  props: [
    'id',
    'selValue',
    'result',
    'width',
    // 'params',
    'configOptions',
    // 'configVariables',
    'serviceArr',
    'isflag',
    'useCacheId',
  ],
  data() {
    return {
      value: this.selValue,
      options: this.configOptions,
      service: {
        resultInfo: null, // 选中接口详情数据
        testResult: null, // 测试返回结果
        fields: null, // this.result, // 返回字段列表
        params: this.params, // 请求参数
        variables: this.configVariables,
      },
      showDetail: false,
      acServiceArr: this.serviceArr,
      controlObj: {
        isControl: this.flag,
      },
      casResult: this.result,
    }
  },
  created() {
    if (this.id) {
      this.optionInit()
      if (this.value) {
        this.getDetails()
      }
    } else {
      alertUtils.alertError('设计ID未获取，请获取设计ID再进行操作', true)
    }
  },
  methods: {
    optionInit() {
      // 选项初始化
      if (this.options && this.options.length > 0) {
        return
      }
      customUtil.getDataInterface(this.id, this.options)
    },
    selService(val) {
      // 接口选择值改变时； 触发

      this.value = val
      if (val) {
        this.getDetails()
      } else {
        this.showDetail = false
        this.service.resultInfo = null
        this.service.testResult = null
        this.service.fields = [] // 返回数据字段
        this.service.params = []
        this.service.variables = []
      }
    },
    getDetails() {
      // 查询接口详情// 查询结果数据
      customUtil.getDataInterfaceInfoInput(
        this.value,
        this.service,
        this.acServiceArr,
        this.controlObj,
        this.deepCopy
      )
    },
    openOrClose() {
      if (!this.value) {
        customUtil.alertWarning('请选择接口', true)
        return
      }
      this.showDetail = !this.showDetail // 先翻转 ，后续逻辑倒过来
      if (this.showDetail) {
        // 表示当前是 收起状态， 将要展开 详情
        if (
          this.service.resultInfo === null ||
          this.service.testResult === null
        ) {
          // 先 判断是否存在值，存在就不查询
          this.getDetails()
        }
        this.initTest()
      }
    },
    initTest() {
      this.$nextTick(() => {
        const editor = window.ace.edit('testResult')
        editor.session.setMode('ace/mode/json')
      })
    },
    // 处理template模板的字段
    deepCopy(oldArr) {
      // oldArr 数组
      let str = ''
      oldArr.forEach(element => {
        if (typeof element === 'object' && element !== null) {
          for (const key in element) {
            if (element[key] instanceof Array && element[key] !== null) {
              str += this.deepCopy(element[key])
            } else {
              str += element[key] + ','
            }
          }
        }
      })
      return str
    },
  },
  watch: {
    value: {
      handler(val) {
        this.$emit('update:selValue', val)
        this.showDetail = false
      },
    },
    options: {
      handler(val) {
        this.$emit('update:configOptions', val)
      },
      deep: true,
    },
    acServiceArr: {
      handler(val) {
        const _that = this
        val.forEach(function (item) {
          if (_that.value === item.resultInfo.id && item.type === 'select') {
            // 普通接口使用下拉框

            _that.casResult = item.resultInfo.keys.split(',')
            // _that.isCascader = false

            _that.service.resultInfo = item.resultInfo
            _that.service.testResult = item.testResult
            _that.service.params = item.params
            _that.service.fields = item.resultInfo.keys.split(',')
            _that.service.variables = item.variables
          }
          if (_that.value === item.resultInfo.id && item.type === 'cascader') {
            // 自定义模板的接口使用级联选择器

            _that.casResult = JSON.parse(item.resultInfo.template)

            // _that.isCascader = true

            _that.service.resultInfo = item.resultInfo
            _that.service.testResult = item.testResult
            _that.service.params = item.params
            _that.service.fields = item.fields
            _that.service.variables = item.variables
          }
        })
      },
      deep: true,
      immediate: true,
    },
    casResult: {
      handler(val) {
        this.$emit('update:result', val)
      },
      deep: true,
      immediate: true,
    },
    'controlObj.isControl': {
      handler(val) {
        this.$emit('update:isflag', val)
      },
      immediate: true,
    },

    // 'service.fields': {
    //   handler (val) {
    //     this.$emit('update:result', val)
    //   },
    //   deep: true
    // },
    'service.params': {
      handler(val) {
        this.$emit('update:params', val)
      },
      deep: true,
    },
    'service.variables': {
      handler(val) {
        this.$emit('update:configVariables', val)
      },
      deep: true,
    },
  },
}
</script>

<style scoped>
.sw-custom-btn {
  margin-left: 10px;
}
.sw-custom-field {
  border-radius: 6px;
  float: left;
  color: white;
  background-color: #409eff;
  margin-left: 10px;
}
.sw-custom-field span {
  padding: 6px;
}
</style>
